import { render, staticRenderFns } from "./tradingProductRewards.vue?vue&type=template&id=37e9e93c&scoped=true"
import script from "./tradingProductRewards.vue?vue&type=script&lang=js"
export * from "./tradingProductRewards.vue?vue&type=script&lang=js"
import style0 from "./tradingProductRewards.vue?vue&type=style&index=0&id=37e9e93c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e9e93c",
  null
  
)

export default component.exports